export const ROUTE_NAME_HOME = "home";
export const ROUTE_NAME_LOGS = "logs";
export const ROUTE_NAME_SHELL = "shell";
export const ROUTE_NAME_FRAME = "frame";
export const ROUTE_NAME_CONFIG = "config";
export const ROUTE_NAME_REQUEST = "request";
export const ROUTE_NAME_SETTINGS = "settings";
